import { render } from "./Index_concept_en_m.vue?vue&type=template&id=9532445e&scoped=true"
import script from "./Index_concept_en_m.vue?vue&type=script&lang=js"
export * from "./Index_concept_en_m.vue?vue&type=script&lang=js"

import "./Index_concept_en_m.vue?vue&type=style&index=0&id=9532445e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9532445e"

export default script